const globalUtil = require("../utilities/globalUtilities");
import { NOT_REFINEMENT_PARAMS } from "../utilities/constants";

/**
 * Updates a query parameter in an URL
 * @param {String} url - the URL to be updated
 * @param {String} name - the name of the query parameter that will be updated
 * @param {String} value - the new value of the query parameter
 * @return {String} - the updated URL
 */
function updateQueryParameter(url, name, value) {
    var re = new RegExp("([?&])" + name + "=.*?(&|#|$)", "i");

    if (value === undefined) {
        if (url.match(re)) {
            return url.replace(re, "$1$2");
        } else {
            return url;
        }
    } else {
        if ((typeof(value) !== "undefined" && typeof(name) === "string") && name.indexOf("prefv") === 0) {
            value = encodeURIComponent(value);
        } 
        
        if (url.match(re)) {
            return url.replace(re, "$1" + name + "=" + value + "$2");
        } else {
            var hash =  "";

            if (url.indexOf("#") !== -1) {
                hash = url.replace(/.*#/, "#");
                url = url.replace(/#.*/, "");
            }

            var separator = url.indexOf("?") !== -1 ? "&" : "?";

            return url + separator + name + "=" + value + hash;
        }
    }
}

/**
 * Returns the value of an URL's query parameter
 * @param {String} url - the URL
 * @param {String} name - the query parameter name
 * @return {String} - the value of the query parameter
 */
function getURLParameter(url, name) {
    return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(url) || [null, ""])[1].replace(/\+/g, "%20")) || null;
}

/**
 * Formats a query string to a JSON object
 * @param {String} queryString -the query string to be formatted
 * @return {Object} - returns the query string formatted as object
 */
const parseQueryStringToObject = queryString => {
    let params = {};

    if (globalUtil.hasNotAllowedValues(queryString)) {
        return params;
    }

    queryString.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
    });

    return params;
};

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return newUrl;
}

/**
 * Removes param from a url
 * @param {string} url - original url
 * @param {string} name - the query parameter name to remove
 * @returns {string} result url without parameter
 */
const removeFromUrl = (url, name) => {
    let rtn = url.split("?")[0];
    let param;
    let params_arr = [];
    let queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === name) {
                params_arr.splice(i, 1);
            }
        }

        if (params_arr.length > 0) {
            rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
};

/**
 * Removes all Refinement params from a url
 * @param {string} url - original url
 * @returns {string} result url without parameter
 */
const removeAllFiltersFromUrl = url => {
    let rtn = url.split("?")[0];
    let param;
    let params_arr = [];
    let queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (NOT_REFINEMENT_PARAMS.indexOf(param) === -1) {
                params_arr.splice(i, 1);
            }
        }

        if (params_arr.length > 0) {
            rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
};

function insertBeforeLastOccurrence(strToSearch, strToFind, strToInsert) {
    let n = strToSearch.lastIndexOf(strToFind);
    if (n < 0) return strToSearch;
    return strToSearch.substring(0, n) + strToInsert + strToSearch.substring(n);
}

export { getURLParameter, updateQueryParameter, parseQueryStringToObject, appendToUrl, removeFromUrl, removeAllFiltersFromUrl, insertBeforeLastOccurrence };
